export default "__VITE_ASSET__ZAnRF_Vp__"